module.exports = "/_next/static/images/financial-accounting-service-2-5f0c5d556c19a1feb16593422df86407.webp";